import React from 'react';
import moment from 'moment';
import { Box, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { apiAction } from '../../../../api/api';
import * as Actions from '../../../../state/Actions';
import { getBusinessInfo } from '../../../../config/cookiesInfo';
import CurrencyFormatter from '../../../common/CurrencyFormatter';
import { NoDataComponent } from '../../../common/NoDataComponent';
import { sumOfArrayByKey, getDateFormat } from '../../../../utils/Utils';
import CustomTypography from '../../../custom/typography/CustomTypography';

import {
    groupByAutoForView,
} from './helper';

import {
    chart_of_account_for_opening_balance
} from '../../../../api/urls';

import {
    CustomTable,
    CustomTableRow,
    CustomTableBody,
    CustomTableHead,
    CustomTableHeadCell,
    CustomTableBodyCell,
    CustomTableContainer,
} from '../../../custom/table/CustomTable';
import DeleteIcon from '@mui/icons-material/Delete';
import { opening_balance_adjustments } from '../../../../utils/Constant';

const ViewAdjustedAccount = ({ refresh, setCondition, setAccounts, deleteAction }) => {
    const navigate = useNavigate();
    const dispatch = Actions.getDispatch(React.useContext);

    const [results, setResults] = React.useState([]);

    const getAdjustedData = async () => {
        let res = await apiAction({
            method: 'post',
            navigate: navigate,
            dispatch: dispatch,
            url: chart_of_account_for_opening_balance(),
            data: {
                adjusted_account: true,
                business_id: getBusinessInfo().id,
            },
        })
        if (res?.success) {
            setAccounts([]);
            if ([...res?.result].length === 0) { setCondition('setup') };
            setResults(groupByAutoForView([...res?.result], 'account_type'));
        }
    }

    React.useEffect(() => {
        getAdjustedData();
    }, [refresh])

    return (
        <div style={{ paddingLeft: '24px', paddingRight: '24px', paddingBottom: '20px' }}>
            <CustomTypography
                text={getBusinessInfo() && `Migration Date: ${moment(getBusinessInfo()?.migration_date).format(getDateFormat())}`}
                sx={{
                    color: '#000000',
                    fontSize: '14px',
                    fontWeight: '700',
                    lineHeight: '18px',
                    fontStyle: 'normal',
                    fontFamily: "Noto Sans",
                }}
            />
            <CustomTableContainer>
                <CustomTable sx={{ mt: 2 }}>
                    <ViewAdjustedAccountHeader />
                    <ViewAdjustedAccountBody data={results} deleteAction={(id, message) => { deleteAction(id, message) }} />
                </CustomTable>
                <Box sx={{ pt: !results.length ? 10 : 0 }} >
                    <NoDataComponent left='0%' top='0%' position={'relative'} data={results} />
                </Box>
            </CustomTableContainer>
        </div>
    )
}

export default ViewAdjustedAccount;

const ViewAdjustedAccountHeader = () => {
    return (
        <CustomTableHead>
            <CustomTableRow>
                <CustomTableHeadCell style={{ width: 200 }}><span>As of Date</span></CustomTableHeadCell>
                <CustomTableHeadCell style={{ width: 200 }}><span>Accounts</span></CustomTableHeadCell>
                <CustomTableHeadCell style={{ width: 200 }} align='right'><span>Debit</span></CustomTableHeadCell>
                <CustomTableHeadCell style={{ width: 200 }} align='right'><span>Credit</span></CustomTableHeadCell>
                <CustomTableHeadCell style={{ width: 10 }} align='right' />
            </CustomTableRow>
        </CustomTableHead>
    )
}
const ViewAdjustedAccountBody = (props) => {
    const { data, deleteAction } = props
    return (
        <CustomTableBody>
            {
                data.map((item, index) => {
                    return (
                        item.account_type ?
                            <React.Fragment key={index}>
                                <CustomTableRow key={index}>
                                    <CustomTableBodyCell sx={{ border: 'none', pb: '0px !important', }}>
                                        <CustomTypography
                                            text={item.account_type.capitalize()}
                                            sx={{
                                                color: '#000000',
                                                fontSize: '16px',
                                                fontWeight: '700',
                                                lineHeight: '18px',
                                                fontStyle: 'normal',
                                                fontFamily: "Noto Sans",
                                            }}
                                        />
                                    </CustomTableBodyCell>
                                </CustomTableRow>
                                {item.transactions.map((item, index) => {
                                    return (
                                        <CustomTableRow key={index}>
                                            <CustomTableBodyCell sx={{ fontWeight: '500' }}><span>{item.account_name !== opening_balance_adjustments ? moment(item.opening_balance_date).format(getDateFormat()) : '-'}</span></CustomTableBodyCell>
                                            <CustomTableBodyCell sx={{ fontWeight: '500' }}><span>{item.account_name}</span></CustomTableBodyCell>
                                            <CustomTableBodyCell sx={{ fontWeight: '500' }} align='right' ><span>
                                                {
                                                    item.debit ?
                                                        <CurrencyFormatter amount={item.debit} currency={item.currency_code} />
                                                        : '-'
                                                }
                                            </span></CustomTableBodyCell>
                                            <CustomTableBodyCell sx={{ fontWeight: '500' }} align='right'><span>
                                                {
                                                    item.credit ?
                                                        <CurrencyFormatter amount={item.credit} currency={item.currency_code} />
                                                        : '-'
                                                }
                                            </span></CustomTableBodyCell>
                                            <CustomTableBodyCell align='right'>
                                                {item.account_name !== opening_balance_adjustments && (
                                                    <IconButton aria-label="delete" sx={{ ":hover": { color: '#2464eb' } }} onClick={() => { deleteAction(item.journal_entry_id, `Do you want to delete the opening balance for  ${item.account_name}`) }}>
                                                        <DeleteIcon sx={{ fontSize: '18px' }} />
                                                    </IconButton>
                                                )}
                                            </CustomTableBodyCell>
                                        </CustomTableRow>
                                    )
                                })
                                }
                            </React.Fragment>
                            : null
                    )
                })
            }
            {data.length ?
                <CustomTableRow sx={{ background: '#FFF7DC', borderTop: '1px solid #FFF0C0', borderBottom: '1px solid #FFF0C0' }}>
                    <CustomTableBodyCell />
                    <CustomTableBodyCell >
                        <CustomTypography
                            text={'Total'}
                            sx={{
                                color: '#000000',
                                fontSize: '14px',
                                fontWeight: '700',
                                lineHeight: '18px',
                                fontStyle: 'normal',
                                textTransform: 'none',
                                fontFamily: "Noto Sans",
                            }}
                        />
                    </CustomTableBodyCell>
                    <CustomTableBodyCell align='right'>
                        <CurrencyFormatter amount={sumOfArrayByKey(data, 'total_debit_amount')} />
                    </CustomTableBodyCell>
                    <CustomTableBodyCell align='right'>
                        <CurrencyFormatter amount={sumOfArrayByKey(data, 'total_credit_amount')} />
                    </CustomTableBodyCell>
                    <CustomTableBodyCell />
                </CustomTableRow>
                : null
            }
        </CustomTableBody>
    )
}